import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ListDataResolverService } from 'src/app/services/list-data-resolver.service';
import { UniversalListData } from 'src/app/interfaces/universal-list-data';
import { ProtoList } from 'src/app/components/pages-partials/card-list/proto-list';
import { Subscription } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-dynamic-list-data',
    templateUrl: '../card-list/card-list.component.html',
    standalone: false
})
export class DynamicListDataComponent
  extends ProtoList<UniversalListData>
  implements OnInit, OnDestroy {
  @Input() private sourceUrl: string;
  @Output() public dataResolved: EventEmitter<
    UniversalListData[]
  > = new EventEmitter<UniversalListData[]>();
  private _dataSubscriber: Subscription;
  @Input('dataSubscriber') set dataSubscriber(params: HttpParams) {
    this.handleSubscriber(this.sourceUrl, params);
  }

  constructor(private dataResolver: ListDataResolverService) {
    super();
  }

  ngOnInit(): void {
    if (!this._dataSubscriber) {
      this.handleSubscriber(this.sourceUrl);
    }
  }
  public reload() {
    console.log("reload");
 
  }
   
  private handleSubscriber(url, params?) {
    this._dataSubscriber = this.dataResolver
      .resolveListData(url, params)
      .subscribe((data) => {
        this.dataResolved.emit(data);
        this.items = data;
        this.setTitles(this.cellProps);
      });
  }

  ngOnDestroy(): void {
    this._dataSubscriber.unsubscribe();
  }
}
